<template>
  <span>
    <h1 v-if="heading && heading.length > 0">{{ heading }}</h1>
    <b-nav class="pt-0 breadcrumb-container d-block d-md-inline-block">
      <b-breadcrumb :items="displayBreadcrumb" />
    </b-nav>
  </span>
</template>

<script>
export default {
  props: ['heading', 'breadcrumb'],
  data() {
    return {
      items: [],
    };
  },
  computed: {
    displayBreadcrumb() {
      return this.breadcrumb ? this.breadcrumb : this.items;
    },
  },
  methods: {
    getUrl(path, sub) {
      const pathToGo = `/${path.split(sub)[0]}${sub}`;
      // if (pathToGo === '/dashboard') {
      //   pathToGo = '/';
      // }
      return pathToGo;
    },

    parseItems() {
      const path = this.$route.path.substr(1);
      let rawPaths = path.split('/');

      console.log(rawPaths);

      // eslint-disable-next-line no-restricted-syntax
      for (const pName in this.$route.params) {
        if (rawPaths.includes(this.$route.params[pName])) {
          rawPaths = rawPaths.filter((x) => x !== this.$route.params[pName]);
        }
      }

      // console.log(path);
      rawPaths.forEach((sub, index) => {
        if (sub === 'dashboard') {
          return;
        }

        const matchedRoute = this.$router.matcher.match(this.getUrl(path, sub));
        console.log(matchedRoute);
        console.log(sub);
        // console.log(this.getUrl(path, sub, index));

        // console.log(this.$router.matcher.match(this.getUrl(path, sub)));
        this.items.push({
          text: matchedRoute.meta.title || sub,
          // text: this.$t(`menu.${sub}`),
          to: this.getUrl(path, sub, index),
        });
      });
    },
  },
  mounted() {
    if (this.breadcrumb) {
      this.items = this.breadcrumb;
    } else {
      this.parseItems();
    }
  },
};
</script>
